import { Tekster } from '../types/generated/apptekster';
import { createApptekstContext } from 'svv-hradm-apptekster-react';

const { ApptekstProvider, useApptekster, MockApptekstProvider } = createApptekstContext<Tekster>();
export { ApptekstProvider, useApptekster, MockApptekstProvider };
